import { __makeTemplateObject, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React, { useState } from 'react';
import styled from 'styled-components';
import { Textarea, themeGet } from '@primer/react';

var StyledTextArea = styled(Textarea)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &::placeholder {\n    color: ", ";\n  }\n"], ["\n  &::placeholder {\n    color: ", ";\n  }\n"])), themeGet("colors.fg.muted"));
var LTTextarea = function LTTextarea(_a) {
  var _b = _a.autoCompleteType,
    autoCompleteType = _b === void 0 ? "name" : _b,
    _c = _a.cols,
    cols = _c === void 0 ? "100%" : _c,
    _d = _a.rows,
    rows = _d === void 0 ? "4" : _d,
    _e = _a.resize,
    resize = _e === void 0 ? "resize" : _e,
    _f = _a.required,
    required = _f === void 0 ? false : _f,
    _g = _a.extraStyle,
    extraStyle = _g === void 0 ? {} : _g,
    _h = _a.id,
    id = _h === void 0 ? "" : _h,
    _j = _a.onChange,
    onChange = _j === void 0 ? function () {} : _j,
    _k = _a.placeholder,
    placeholder = _k === void 0 ? "" : _k,
    _l = _a.value,
    value = _l === void 0 ? "" : _l;
  var _m = useState(value),
    text = _m[0],
    setText = _m[1];
  var handleChange = function handleChange(e) {
    setText(e.target.value);
    onChange(e.target.value);
  };
  return /*#__PURE__*/React.createElement(StyledTextArea, {
    autoComplete: autoCompleteType,
    cols: cols,
    rows: rows,
    resize: resize,
    required: required,
    id: id,
    sx: __assign({
      background: "#f7f7f7"
    }, extraStyle),
    placeholder: placeholder,
    onChange: handleChange,
    value: text
  });
};
var templateObject_1;

export { LTTextarea, LTTextarea as default };
